module.exports = __webpack_public_path__ + "img/HyDry_sRGB_neg_white.0ac700a9.png";